/**
 * @IMPORTANT
 * DO NOT EDIT THIS FILE. It is generated at build-time, and it is git-ignored. If you want to modify
 * the contents of this file, edit "scripts/generate-variant.js" instead.
 */

import merge from 'lodash.merge';

// Import fonts.
import './Style/console/heyday/fonts';

// Import variant overrides
import './Style/console/heyday/variant-overrides.less';

// Import variant's strings.
import en from './i18n/console/en.json';
import enVariant from './i18n/console/en_heyday.json';
import enPrivacyPolicy from './i18n/webapp/heyday/en/privacy-policy.html';
import enTermsOfUse from './i18n/webapp/heyday/en/terms-of-use.html';

// Import variant-specific images.
import logoColor from './Assets/Images/console/heyday/logo-color.svg';
import logoWhite from './Assets/Images/console/heyday/logo-white.svg';
import logoSmallWhite from './Assets/Images/console/heyday/logo-small-white.svg';
import logoVertical from './Assets/Images/console/heyday/logo-vertical.svg';
import homeHeader from './Assets/Images/console/heyday/home-header.jpg';
import listSectionHeader from './Assets/Images/console/heyday/list-section-header.jpg';
import usersHeader from './Assets/Images/console/heyday/users-header.jpg';
import anonymousBackground from './Assets/Images/console/heyday/login-page.jpg';
import locationsHeader from './Assets/Images/console/heyday/locations-header.jpg';
import logoBlack from './Assets/Images/console/heyday/logo-black.svg';
import grayPineapple from './Assets/Images/console/heyday/grey-pineapple.svg';
// # @TODO - Enlever ça partout, c'est un placeholder
import androidAppleApps from './Assets/Images/console/heyday/android-apple-apps.svg';
import settingsHeader from './Assets/Images/heyday/settings-header.png';
import webAppHomeHeader from './Assets/Images/console/heyday/webapp-home-header.png';
import utilitiesBackground from './Assets/Images/webapp/heyday/background-utilities-layout.jpg';
import verdocsLogo from './Assets/Images/console/heyday/VerdocsLogo.png';
import bbotLogo from './Assets/Images/console/heyday/bbotLogo.svg';
import pineappleBlack from './Assets/Images/console/heyday/pineapple-black.svg';

// Build legal pages Map
interface LegalPages {
    privacyPolicy: string;
    termsOfUse: string;
}

const legalPages: Map<string, LegalPages> = new Map();
legalPages.set('en', {
    privacyPolicy: enPrivacyPolicy,
    termsOfUse: enTermsOfUse,
});

// Expose variant specifics.
// Merge variant into base strings.
export const i18nVariant = { en: merge(en, enVariant) };
export { legalPages };
export const images = {
    logoColor,
    logoWhite,
    logoSmallWhite,
    logoVertical,
    homeHeader,
    listSectionHeader,
    usersHeader,
    anonymousBackground,
    locationsHeader,
    logoBlack,
    grayPineapple,
    androidAppleApps,
    settingsHeader,
    webAppHomeHeader,
    utilitiesBackground,
    verdocsLogo,
    bbotLogo,
    pineappleBlack,
};
export const theme = {
    'font-family': 'Poppins, serif',
    'heading-font-family': 'Poppins, serif',
    'font-size-base': '14px',
    'design-s2021-pure-black': '#000000',
    'design-s2021-pure-white': '#ffffff',
    'design-s2021-success-900': '#17361c',
    'design-s2021-success-500': '#4cb25d',
    'design-s2021-success-100': '#e4f0e6',
    'design-s2021-alert-900': '#4b0f01',
    'design-s2021-alert-500': '#ff453a',
    'design-s2021-alert-100': '#ffe7e5',
    'design-s2021-heyday-primary-900': '#4e4732',
    'design-s2021-heyday-primary-700': '#847348',
    'design-s2021-heyday-primary-500': '#b19f71',
    'design-s2021-heyday-primary-300': '#d0c5aa',
    'design-s2021-heyday-primary-100': '#f1eee4',
    'design-s2021-heyday-secondary-500': '#d6be89',
    'design-s2021-heyday-grayscale-900': '#19191a',
    'design-s2021-heyday-grayscale-700': '#3a3a3b',
    'design-s2021-heyday-grayscale-500': '#727274',
    'design-s2021-heyday-grayscale-300': '#b2b2b3',
    'design-s2021-heyday-grayscale-200': '#d8d8d9',
    'design-s2021-heyday-grayscale-100': '#e6e7e8',
    'design-s2021-passport-primary-900': '#0c1527',
    'design-s2021-passport-primary-700': '#192b4d',
    'design-s2021-passport-primary-500': '#315498',
    'design-s2021-passport-primary-300': '#6588cd',
    'design-s2021-passport-primary-100': '#e0e7f5',
    'design-s2021-passport-secondary-500': '#aec4dc',
    'design-s2021-passport-grayscale-900': '#2a2723',
    'design-s2021-passport-grayscale-700': '#3b3731',
    'design-s2021-passport-grayscale-500': '#565048',
    'design-s2021-passport-grayscale-300': '#a39b8f',
    'design-s2021-passport-grayscale-200': '#dddad5',
    'design-s2021-passport-grayscale-100': '#e8e6e3',
    'design-black': '#101820',
    'design-black-80': '#454142',
    'design-black-60': '#6a6768',
    'design-black-40': '#8d8f8e',
    'design-black-20': '#9b9d9d',
    'design-black-5': '#f3f3f4',
    'design-primary-100': '#a89968',
    'design-primary-80': '#baae87',
    'design-primary-60': '#cdc4a8',
    'design-primary-40': '#dfdac8',
    'design-primary-20': '#eeebe2',
    'design-primary-5': '#f9f8f5',
    'design-secondary-100': '#ceb888',
    'design-secondary-80': '#d8c7a1',
    'design-secondary-60': '#e3d6ba',
    'design-secondary-40': '#ece3d0',
    'design-secondary-20': '#f5f0e6',
    'design-secondary-5': '#fcfbf8',
    'design-input-border-gray': '#b2b2b3',
    'design-success': '#98dbce',
    'design-success-100': '#e4f0e6',
    'design-alert': '#faaa8d',
    'burning-red': '#642734',
    'burning-red-80': '#e03e52',
    'cactus-green': '#273f35',
    'cactus-green-80': '#497b55',
    'alert-100': '#feded7',
    'primary-color': '#a89968',
    'primary-1': '#baae87',
    'primary-2': '#cdc4a8',
    'primary-3': '#dfdac8',
    'primary-4': '#eeebe2',
    'primary-5': '#f9f8f5',
    'primary-900': '#ceb888',
    'primary-700': '#847348',
    'primary-500': '#b19f71',
    'primary-300': '#d0c5aa',
    'primary-100': '#f1eee4',
    'secondary-color': '#ceb888',
    'secondary-1': '#d8c7a1',
    'secondary-2': '#e3d6ba',
    'secondary-3': '#ece3d0',
    'secondary-4': '#f5f0e6',
    'secondary-5': '#fcfbf8',
    'secondary-500': '#d6be89',
    black: '#101820',
    'black-1': '#454142',
    'black-2': '#6a6768',
    'black-3': '#8d8f8e',
    'black-4': '#9b9d9d',
    'black-5': '#f3f3f4',
    'pure-black': '#000',
    'gray-900': '#19191a',
    'gray-700': '#3a3a3b',
    'gray-500': '#727274',
    'gray-300': '#b2b2b3',
    'gray-200': '#d8d8d9',
    'gray-100': '#e6e7e8',
    white: '#fff',
    'status-closed': '#8d8f8e',
    'error-red': '#faaa8d',
    'error-red-1': '#faaa8d',
    'success-green': '#98dbce',
    'success-green-1': '#98dbce',
    'success-green-2': '#e4f0e6',
    'pending-orange': '#ffc700',
    'login-gray': '#19212a',
    'bg-light': '#e1e1e1',
    'dark-grey': '#43434c',
    'page-background': '#e6e7e8',
    'input-background': '#f4f5f6',
    'input-border': '#b2b2b3',
    scrollbar: '#b2b2b3',
    'notFoundPage-color': '#43434c',
    'error-color': '#e03e52',
    'alert-error-border-color': '#feded7',
    'alert-error-bg-color': '#feded7',
    'alert-error-icon-color': '#642734',
    'loading-color': '#ceb888',
    'height-base': '50px',
    'btn-padding-horizontal-base': '30px',
    'alert-with-description-padding-vertical': '18px',
    'height-lg': '60px',
    'padding-lg': '24px',
    'padding-md': '16px',
    'padding-sm': '12px',
    'padding-xs': '8px',
    'padding-xss': '4px',
    'text-color': '#101820',
    'link-color': '#a89968',
    'layout-sider-background': '#454142',
    'layout-trigger-background': 'rgba(@pure-black, 0.6)',
    'menu-dark-bg': '#454142',
    'menu-dark-color': '#fff',
    'menu-dark-item-active-bg': '#baae87',
    'menu-inline-toplevel-item-height': '56px',
    'menu-item-font-size': '14px',
    'heading-super-size': 'ceil(@font-size-base * 5)',
    'heading-1-size': 'ceil(@font-size-base * 3.42)',
    'heading-2-size': 'ceil(@font-size-base * 2.28)',
    'heading-3-size': 'ceil(@font-size-base * 2)',
    'heading-4-size': 'ceil(@font-size-base * 1.5)',
    'typography-title-font-weight': 'bold',
    'btn-font-weight': 'bold',
    'btn-border-radius-base': '0',
    'btn-square-only-icon-size-lg': '24px',
    'btn-ghost-color': '#fff',
    'btn-ghost-bg': 'transparent',
    'btn-ghost-border': 'transparent',
    'btn-default-color': '#a89968',
    'btn-default-bg': '#fff',
    'btn-default-border': '#fff',
    'btn-danger-color': '#642734',
    'btn-danger-bg': '#feded7',
    'btn-danger-border': 'none',
    'breadcrumb-separator-color': '#ceb888',
    'breadcrumb-last-item-color': '#8d8f8e',
    'breadcrumb-link-color': '#454142',
    'breadcrumb-separator-margin': '12px',
    'breadcrumb-link-color-hover': '#baae87',
    'dropdown-vertical-padding': '10px',
    'dropdown-edge-child-vertical-padding': '10px',
    'modal-body-padding': '20px 40px',
    'modal-header-padding-vertical': '30px',
    'modal-header-padding-horizontal': '40px',
    'border-color-base': '#eeebe2',
    'border-color-split': '#eeebe2',
    'table-header-bg': '#fff',
    'table-header-color': '#101820',
    'table-bg': '#f9f8f5',
    'table-padding-vertical': '10px',
    'table-padding-horizontal': '20px',
    'pagination-font-family': 'Poppins, serif',
    'pagination-item-bg-active': '#f5f0e6',
    'pagination-font-weight-active': 'bold',
    'pagination-item-size': '40px',
    'form-item-margin-bottom': '40px',
    'menu-item-color': '#3a3a3b',
    'menu-item-active-bg': '#f1eee4',
    'booking-table-cell-odd': '#fff',
    'booking-table-cell-even': '#ededed',
    'booking-table-cell-past': '#bdbdbd',
};
